"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentChangelog = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
/**
 * <mm-component-changelog>
 * 컴포넌트 문서 최하단에 API·동작 변경 이력을 최신순으로 나열한다.
 */
let ComponentChangelog = class ComponentChangelog extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = 'Changelog';
        this.items = [];
    }
    render() {
        if (this.items.length === 0)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading>${this.heading}</mm-heading>
      <mm-surface variant="outlined" radius="large">
        <div class="changelog-items">${this.items.map(item => this.renderItem(item))}</div>
      </mm-surface>
    `;
    }
    renderItem(item) {
        return (0, lit_1.html) `
      <div class="changelog-item">
        <mm-text color="light">${item.date}</mm-text>
        <mm-paragraph>${item.description}</mm-paragraph>
      </div>
    `;
    }
};
ComponentChangelog.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
      padding-top: var(--space-section);
    }

    .changelog-items {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    .changelog-item {
      display: flex;
      gap: var(--space-4);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentChangelog.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentChangelog.prototype, "items", void 0);
ComponentChangelog = __decorate([
    (0, decorators_js_1.customElement)('mm-component-changelog')
], ComponentChangelog);
exports.ComponentChangelog = ComponentChangelog;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LWNoYW5nZWxvZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC1jaGFuZ2Vsb2cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCwrQkFBNEI7QUFRNUI7OztHQUdHO0FBRUksSUFBTSxrQkFBa0IsR0FBeEIsTUFBTSxrQkFBbUIsU0FBUSxnQkFBVTtJQUEzQzs7UUFvQnVCLFlBQU8sR0FBRyxXQUFXLENBQUE7UUFDakIsVUFBSyxHQUFpQyxFQUFFLENBQUE7SUFxQjFFLENBQUM7SUFuQkMsTUFBTTtRQUNKLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEtBQUssQ0FBQztZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTNDLE9BQU8sSUFBQSxVQUFJLEVBQUE7b0JBQ0ssSUFBSSxDQUFDLE9BQU87O3VDQUVPLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQzs7S0FFL0UsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVLENBQUMsSUFBZ0M7UUFDakQsT0FBTyxJQUFBLFVBQUksRUFBQTs7aUNBRWtCLElBQUksQ0FBQyxJQUFJO3dCQUNsQixJQUFJLENBQUMsV0FBVzs7S0FFbkMsQ0FBQTtJQUNILENBQUM7O0FBeENNLHlCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQWtCbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7bURBQXNCO0FBQ2pCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQztpREFBeUM7QUFyQjdELGtCQUFrQjtJQUQ5QixJQUFBLDZCQUFhLEVBQUMsd0JBQXdCLENBQUM7R0FDM0Isa0JBQWtCLENBMEM5QjtBQTFDWSxnREFBa0IifQ==